var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input" }, [
    _c(
      "label",
      {
        staticClass:
          "mdc-text-field input__field mdc-text-field--outlined mdc-text-field--with-trailing-icon",
        class: {
          "mdc-text-field--valid": _vm.validState,
          "mdc-text-field--disabled": _vm.disabled,
          "mdc-text-field--invalid": _vm.invalid
        }
      },
      [
        _c("bk-outline-notched", { attrs: { label: _vm.label, id: _vm.id } }),
        _vm._v(" "),
        _c("input", {
          staticClass: "mdc-text-field__input",
          class: {
            "data-hj-allow": _vm.allowHotjarRecording,
            "data-hj-suppress": !_vm.allowHotjarRecording
          },
          attrs: {
            disabled: _vm.disabled,
            type: _vm.type,
            id: _vm.id,
            "aria-controls": _vm.helperTextId,
            "aria-describedby": _vm.helperTextId,
            maxlength: _vm.maxLength,
            autocomplete: "off"
          },
          domProps: { value: _vm.trimmedValue },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event.target.value)
            },
            change: function($event) {
              return _vm.$emit("change", $event.target.value)
            },
            focus: function($event) {
              return _vm.$emit("focus")
            },
            blur: function($event) {
              return _vm.$emit("blur")
            }
          }
        }),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "i",
              {
                staticClass:
                  "mdc-text-field__icon mdc-text-field__icon--trailing",
                attrs: { tabindex: "-1" }
              },
              [_c("bk-loading-spinner")],
              1
            )
          : _c(
              "i",
              {
                staticClass:
                  "material-icons mdc-text-field__icon mdc-text-field__icon--trailing",
                attrs: { tabindex: "0", role: "button" }
              },
              [_vm._v(_vm._s(_vm.icon))]
            )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mdc-text-field-helper-line" }, [
      _c(
        "p",
        {
          staticClass:
            "mdc-text-field-helper-text mdc-text-field-helper-text--persistent mdc-text-field-helper-text--validation-msg",
          class: { "mdc-text-field-helper-text--disabled": !_vm.showHelper },
          attrs: { id: _vm.helperTextId, "aria-hidden": "true" }
        },
        [_vm._v(_vm._s(_vm.helperText))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }